import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { LoansApplicationActionCardComponent } from '@brightside-web/desktop/feature/loans';
import { LoansDashboardCardComponent } from '@brightside-web/desktop/feature/loans';
import { Subject, filter, takeUntil, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoansCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _unsub$ = new Subject<void>();

  constructor() {
    this._serviceInventory
      .getService('loan_application')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
            case ServiceState.PENDING:
              this.registerLoansApplicationActionCard(service.route);
              break;
            case ServiceState.MAINTENANCE:
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();

    this._serviceInventory
      .getService('loan_dashboard')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
            case ServiceState.PENDING:
              this.registerLoansDashboardCard(service.route);
              break;
            case ServiceState.MAINTENANCE:
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.next();
  }

  private registerLoansApplicationActionCard(vendor?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'loan_application',
      component: 'LoansApplicationActionCardComponent',
      componentRef: LoansApplicationActionCardComponent,
      data: { vendor },
      order: 1,
      section: HomeFeedSection.ACTIONS,
    });
  }

  private registerLoansDashboardCard(vendor?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'loan_dashboard',
      component: 'LoansDashboardCardComponent',
      componentRef: LoansDashboardCardComponent,
      data: { vendor },
      order: 1,
      section: HomeFeedSection.REPAYMENTS,
    });
  }
}
